<template>
  <ul v-if="listItem" class="p-h-column-list">
    <li
      v-for="({ label, detail }, key) in listItem"
      :key="key"
      class="p-h-column-list__item"
      :class="columnSizeClassName"
    >
      <div class="p-h-column-list__body">
        <SmallText>{{ label }}</SmallText>
        <div v-if="typeof detail == 'string'">
          <span v-if="redemptionType === 3" v-html="giftCode(detail)"></span>
          <span v-else>{{ giftCode(detailText) }}</span>
        </div>
        <div v-else>
          <p
            v-for="(detailText, detailKey) in detail"
            :key="detailKey"
            class="p-the-h03__text"
          >
            <span
              v-if="redemptionType === 3"
              v-html="giftCode(detailText)"
            ></span>
            <span v-else>{{ giftCode(detailText) }}</span>
          </p>
        </div>
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import SmallText from "@/common/components/atoms/SmallText.vue";

@Options({
  props: {
    redemptionType: { type: Number, required: true },
    listItem: { type: Array || Boolean, required: true },
    columnSize: { type: String, default: "" }
  },
  components: {
    SmallText
  }
})
export default class HSpecColumnList extends Vue {
  redemptionType!: number;
  listItem!: any[] | boolean;
  columnSize!: string;

  get columnSizeClassName() {
    const { columnSize } = this;

    const resultClassName =
      columnSize !== "" ? `p-h-column-list__item--${columnSize}` : "";

    return resultClassName;
  }

  giftCode(text: string) {
    if (this.redemptionType === 3) {
      return `<a href="${text}" target="_blank">${text}</a>`;
    }

    return text;
  }
}
</script>

<style lang="scss" scoped>
.p-h-column-list {
  @include pc {
    margin: rem(-8) 0 0 rem(-16);
  }
  @include sp {
    margin: rem(-20) 0 0 rem(-16);
  }
  display: flex;
  flex-wrap: wrap;

  &__item {
    @include sp {
      margin-top: rem(20);
    }
    min-width: rem(56);
    margin: rem(8) 0 0 rem(16);

    &--m {
      min-width: rem(150);
    }

    &--l {
      width: 100%;
      min-width: initial;
      margin-top: rem(16);
    }
  }

  &__body {
  }

  &__text {
  }
}
</style>
